import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { Tab } from 'legacyComponents/styled/lib';

import { OpenProjectIssueCard } from 'legacyComponents/cards/types/projectIssue';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { NoDataCard } from 'legacyComponents/cards/types/noData';

@withNamespaces()
@observer
export class OpenIssuesTab extends React.Component {
  clickOpenIssue = () => {
    const { manager } = this.props;
    manager.OpenIssueForm();
  };

  render() {
    const { app, project, manager, dataTestId } = this.props;
    const issues = app.manager.issuesConn.arrayApp;

    if (app.openIssuesCount < 1) {
      return (
        <NoDataCard
          type='openIssues'
          manager={manager}
          owner={project.canUpdate}
          dataTestId={dataTestId}
        />
      );
    }
    return (
      <Tab noShadow>
        <CardSection
          title=''
          cardApp={issues}
          CardComponent={OpenProjectIssueCard}
          noMarginTop
          dataTestId={dataTestId}
        />
      </Tab>
    );
  }
}

OpenIssuesTab.propTypes = {
  app: PropTypes.object,
  manager: PropTypes.object,
  project: PropTypes.object,
  dataTestId: PropTypes.string,
};
